export const QUERY_KEYS = {
    GETALLPRODUCTS: "getAllProducts",
    GETALLCATEGORIES: "getAllCategories",
    NEWGETALLCATEGORIES: "newGetAllCategories",
    GETALLCATEGORYBASEDPRODUCTS: "getAllCategoryBasedProducts",
    GETALLSUBCATEGORIES: "getAllSubCategories",
    GETALLBRANDS: "getAllBrands",
    GETSEARCHPRODUCTS: "getSearchProducts",
    GETLEGALNOTICE: "getLegalNotice",
    GETTERMSANDCONDITIONS: "getTermsAndConditions",
    GETABOUTUS: "getAboutUs",
    GETALLBRANDBASEDPRODUCTS: "getAllBrandBasedProducts",
    GETALLSTOCKSTATUSBASEDPRODUCTS: "getAllStockStatusBasedProducts",
    GETALLSORTEDPRODUCTS: "getAllSortedProducts",
    GETFILTEREDPRODUCTS: "getFilteredProducts",
    GETNEWFILTEREDPRODUCTS: "getNewFilteredProducts",
    GETCONTACTFORM: "getContactForm",
    GETALLBLOGS: "getAllBlogs",
    GETBLOGDETAILS: "getBlogDetails",
    GETBLOGDETAILSUSINGSLUG: "getBlogDetailsUsingSlug",
    GETBLOGSBYCATEGORY: "getBlogsByCategory",
    GETBLOGTAGS: "getBlogTags",
    GETLAUNCHPRODUCTDETAILS: "getLaunchProductDetails",
    GETLAUNCHPRODUCTS: "getLaunchProducts",
    GETCATEGORYIDUSINGSLUG: "getCategoryIdUsingSlug",
    GETNEWPRODUCTDETAILS: "getNewProductDetails",
    GETNEWPRODUCTDETAILSBYSLUG: "getNewProductDetailsBySlug",
};